module.exports = __webpack_public_path__ + "img/video10.ffa114c8.jpg";